import React from 'react';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/dee47753818cc13de4aae5153ccd2db8.jpg"
          alt="Private Health Insurance Consultants Houston TX"
          title="Data Health Insurance Consultants - Private Health Insurance Houston"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-8 lg:px-12 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 bg-brand-400 rounded-full animate-pulse"></span>
          <span className="text-white text-sm font-medium">
            Houston&apos;s Trusted Independent Broker &bull; Open 24/7
          </span>
        </div>

        <h2 className="text-5xl md:text-7xl font-display font-bold text-white leading-tight mb-6">
          Private Health Insurance
          <br />
          <span className="text-brand-400">Made Simple</span> in Houston
        </h2>

        <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
          <strong>Data Health Insurance Consultants</strong> is an independent broker specializing in private
          medical insurance for individuals and companies. Expert advice, market comparisons, and personalized
          plans — available around the clock.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="#contact"
            className="px-8 py-4 bg-brand-500 text-white text-base font-semibold rounded-lg hover:bg-brand-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-brand-500/30"
          >
            Get Your Free Quote
          </a>
          <a
            href="tel:7138049039"
            className="px-8 py-4 bg-white/15 backdrop-blur-sm text-white text-base font-medium rounded-lg hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-brand-400"></i>
            </div>
            Call (713) 804-9039
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {[
            { icon: 'ri-user-heart-line', label: 'Individual Plans' },
            { icon: 'ri-group-line', label: 'Family Coverage' },
            { icon: 'ri-building-2-line', label: 'Company Plans' },
            { icon: 'ri-heart-pulse-line', label: 'Medicare Supplements' },
          ].map((item) => (
            <div
              key={item.label}
              className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-4 flex items-center gap-3 hover:bg-white/20 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-brand-500/20">
                <i className={`${item.icon} text-xl text-brand-400`}></i>
              </div>
              <span className="text-white text-sm font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
